import { ehUuid } from '@nexital/shared';

// Espaço de trabalho = empresa + quadro, sempre pela URL /e/{empresa}/q/{quadro} (RQ-ACE-011).
// A sessão não guarda empresa: cada aba pode estar num espaço diferente.
// Licitação aberta sobre o quadro: /e/{empresa}/q/{quadro}/l/{processo} (RQ-LIC-003).

export type Espaco = { empresaUuid: string; quadroUuid: string; processoUuid?: string };
type EmpresaComQuadros = { uuid: string; quadros: { uuid: string }[] };

const CAMINHO = /^\/e\/([^/]+)\/q\/([^/]+)(?:\/l\/([^/]+))?\/?$/;

export function lerEspaco(caminho: string): Espaco | null {
  const [, empresaUuid, quadroUuid, processoUuid] = CAMINHO.exec(caminho) ?? [];
  if (!empresaUuid || !quadroUuid || !ehUuid(empresaUuid) || !ehUuid(quadroUuid)) return null;
  if (processoUuid === undefined) return { empresaUuid, quadroUuid };
  return ehUuid(processoUuid) ? { empresaUuid, quadroUuid, processoUuid } : null;
}

export function caminhoDoEspaco({ empresaUuid, quadroUuid, processoUuid }: Espaco) {
  const quadro = `/e/${empresaUuid}/q/${quadroUuid}`;
  return processoUuid ? `${quadro}/l/${processoUuid}` : quadro;
}

/**
 * O espaço pedido na URL, se a pessoa tem acesso; sem pedido, o primeiro quadro disponível.
 * 'sem-acesso' quando o pedido não está entre os espaços da pessoa; null quando ela não tem nenhum quadro.
 */
export function escolherEspaco(empresas: EmpresaComQuadros[], pedido: Espaco | null): Espaco | 'sem-acesso' | null {
  if (pedido) {
    const empresa = empresas.find((e) => e.uuid === pedido.empresaUuid);
    return empresa?.quadros.some((q) => q.uuid === pedido.quadroUuid) ? pedido : 'sem-acesso';
  }
  const empresa = empresas.find((e) => e.quadros.length > 0);
  return empresa ? { empresaUuid: empresa.uuid, quadroUuid: empresa.quadros[0]!.uuid } : null;
}
